import BasicTab2 from "./BasicTab2"
import {Link} from "react-router-dom"

import { useEffect,useState } from "react"
import ListItems from "./ListItems"
export default function SlideList({open=true,setOpen,symbol}){

    const [resultSym,setResultSym] = useState([])
    const [notFound,setNotFound] = useState(false)
    const [search,setSearch] = useState('')
    const [result,setResult] = useState([])
    const [tabChange,setTabChange] = useState(false)
    const [key,setKey] = useState(0)



    function hanldleSearch(event) {
        setSearch(event.target.value)

    }

    useEffect(()=>{
        const results = symbol.filter(({symbol,persionName}) => {
               return(
                   persionName.includes(search))
                 ||
                   symbol.includes(search.toUpperCase())
           });
     
           if (search){
             if(results.length === 0){
                 setNotFound(true)
             }else {
                 setNotFound(false)
      
             }
         }
     
           setResultSym(results)
         },[search])

         function handleTabs(value) {
            console.log("it is handle tab ....")
            console.log(value)
            let k = Math.random()
    
    
             if (value === 1) {
                const res = symbol.sort(function (a, b) {
                    return b.changeRate - a.changeRate
                }) 
                setResult(res)
               setTabChange(true)
                           setKey(k)
    
    
               }
               else if (value === 3) {
                const res = symbol.sort(function (a, b) {
                    return a.changeRate - b.changeRate
                })
                setResult(res)
               setTabChange(true)
                           setKey(k)
    
    
               }
    
            else if (value === 4) {
                    const res = symbol.sort(function (a, b) {
                        return a.buy - b.buy
                    })
                console.log(res)
                    setResult(res)
                setKey(k)
                setTabChange(true)
    
    
            }
             else if (value === 0) {
                 console.log(symbol)
                    setResult(symbol)
                setTabChange(false)
                            setKey(k)
    
    
                } else if (value === 5) {
                    const res = symbol.sort(function (a, b) {
                        return b.buy - a.buy
                    })
                    setResult(res)
                    setTabChange(false)
                            setKey(k)
    
    
                } else if (value === 2) {
                    const res = symbol.filter(sym => sym.type === 'leve')
                    setResult(res)
                    setTabChange(false)
                            setKey(k)
    
    
    
                }
    
    
    
        }







    return(
        <div className={`slide-list-item ${open ? 'slide2020-open' : '' } `}>


            <div  className="d-flex ptb-24"> 

                <span className="w-50 font727452324">
                    لیست ارزهای دیجیتال

                </span>

                <div className="w-50 text-left" onClick={()=>{setOpen(false)}}>
                <img className="close-icon" src="https://static.sinatether.com/images/Close.svg" alt="" />

                </div>

            </div>

            <div className="row w-100 rsearch sdkjerywgrwrw2342 position-relative">
                <img className="search-icon" src="https://static.sinatether.com/images/search.svg" alt="جستجو ارزهای دیجیتال" />
            <input className={'input-search text-normal pr-45 search-input21'} placeholder={' جستجو ارز دیجیتال'} onChange={hanldleSearch}/>

            </div>


            <BasicTab2 handleTabs={handleTabs}/>







            <div>
            <div className="ptb-12 itemrowdiv "><div className="col-4 pl-4 text-large text-normal ">نام</div><div className="col-4 text-center pl-0 text-large text-normal">
                                           
                                           قیمت جهانی
 
                                            
            </div><div className="col-4  text-large text-normal">تغییرات24h</div></div>


            <div className="subdiv2002">

            {  search != '' ?

            resultSym.length>0 ?

                   <ListItems symbol={resultSym} setOpen={setOpen}/>

             :

             <div className="text-center pt-3">

                <img src="https://static.sinatether.com/images/notfound.svg" alt="" />

                <div className="pt-3 text-large text-mute color24">
                 موردی یافت نشد!
                </div>


             </div>
            :

            result && result.length > 0?
            <>
            
        <Link className="itemrowdiv"
            to={`/USDT`} onClick={()=>setOpen(false)}>
            
            
                        <Link className="col-4 pointer linkStyle"
                       to={`/USDT`} onClick={()=>setOpen(false)}>
                        <div className="text-black">
                            <img className="imgcoin2002 "
                                 src={`https://static.sinatether.com/CoinsImg/USDT.png`} alt={""}/>
                            <span
                                className="spanHeaderAcc">  <span
                                className="ft-external-link text-large text-normal dis-grid text-dark">تتر
                                <span
                                className="text-medium text-muted">USDT</span>
                                </span>
                                
                                </span>
            
                        </div>
                    </Link>
            
            
            
            
                    <div
                        className="col-4 pointer text-right text-blue-primery text-large text-dark line-height-48"
                    >
                        1356
                     
                        </div>
                            <div
                            className="col-3 pointer text-right text-blue-primery text-large text-center priceTt pt-13"
                        >

                            0

                            
            
                   
            
            
                        </div>
                        </Link>

            <ListItems symbol={result} setOpen={setOpen} />

            </>

            :
            <>

        <Link className="itemrowdiv"
            to={`/USDT`} onClick={()=>setOpen(false)}>
            
            
                        <Link className="col-4 pointer linkStyle"
                       to={`/USDT`} onClick={()=>setOpen(false)}>
                        <div className="text-black">
                            <img className="imgcoin2002 "
                                 src={`https://static.sinatether.com/CoinsImg/USDT.png`} alt={""}/>
                            <span
                                className="spanHeaderAcc">  <span
                                className="ft-external-link text-large text-normal dis-grid text-dark">تتر
                                <span
                                className="text-medium text-muted">USDT</span>
                                </span>
                                
                                </span>
            
                        </div>
                    </Link>
            
            
            
            
                    <div
                        className="col-4 pointer text-right text-blue-primery text-large text-dark line-height-48"
                    >
                        1
                     
                        </div>
                            <div
                            className="col-3 pointer text-right text-blue-primery text-large priceTt pt-13"
                        >

                            
            
                   
            
            
                        </div>
                        </Link>


            <ListItems symbol={symbol} setOpen={setOpen} />

            </>



            }

            
            
            
            </div>

            






            </div>






            </div>




        
        
        
        
    )
}